import { render, staticRenderFns } from "./CustomerInsuranceLegalExpense.vue?vue&type=template&id=60b84971"
import script from "./CustomerInsuranceLegalExpense.vue?vue&type=script&lang=js"
export * from "./CustomerInsuranceLegalExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports